import { Group } from '@mantine/core';
import type { IconNames } from '@repo/foundations';
import { Icon, Text } from '@repo/foundations';
import type { ColorNames } from '@repo/theme/utils';
import type { Automation } from '../../api';

const IconByRawStatus: Record<
	string,
	{ iconName: IconNames; iconColor?: ColorNames; iconFillColor?: ColorNames }
> = {
	completed: {
		iconName: 'circleCheckFilled',
		iconFillColor: 'icon/success/default',
	},
	failed: {
		iconName: 'alertCircleFilled',
		iconFillColor: 'icon/critical/default',
	},
	running: { iconName: 'loader2', iconColor: 'icon/primary/default' },
	reverted: { iconName: 'arrowBackUp', iconColor: 'icon/primary/default' },
	applying: { iconName: 'refresh', iconColor: 'icon/info/default' },
	pending: {
		iconName: 'clock',
		iconColor: 'icon/info/default',
	},
	discarded: {
		iconName: 'circleXFilled',
		iconFillColor: 'icon/primary/disabled',
	},
};

function formatLabel(status: string): string {
	const s = status.toLowerCase();
	return s.charAt(0).toUpperCase() + s.slice(1);
}

export function AutomationV2StatusColumn({
	automation,
}: {
	automation: Automation;
}) {
	interface AutomationWithLastStatus extends Automation {
		last_run_status?: string | null;
	}

	const raw: string | undefined = (
		automation as AutomationWithLastStatus
	).last_run_status?.toLowerCase();

	let iconConfig: {
		iconName: IconNames;
		iconColor?: ColorNames;
		iconFillColor?: ColorNames;
	} = { iconName: 'circleCheckFilled', iconFillColor: 'icon/success/default' };
	let label: string | undefined;
	if (raw) {
		const resolvedRawStatus = (
			raw in IconByRawStatus ? raw : 'pending'
		) as keyof typeof IconByRawStatus;
		iconConfig = IconByRawStatus[resolvedRawStatus];
		label = formatLabel(resolvedRawStatus);
	} else {
		iconConfig = {
			iconName: 'lineDashed',
			iconColor: 'icon/secondary/default',
		};
	}

	return (
		<Group spacing="2xs">
			<Icon
				name={iconConfig.iconName}
				color={iconConfig.iconColor}
				fillColor={iconConfig.iconFillColor}
			/>
			<Text size="sm">{label}</Text>
		</Group>
	);
}
